export class BaseUserModel {
  userId: number = 0;
  companyId: number = 0;
  imsDefaultWarehouseId: number = 0;
  fullName: string = '';
  profileImgUrl: string = '';
  displayName: string = '';
  userRole: string[] = [];
}

export class UserModel {
  id: number = 0;
  firstName: string = '';
  middleName?: string = '';
  lastName: string = '';
  displayName?: string = '';
  companyId: number = 0;
  status: number = 0;
  userName: string = '';
  email: string = '';
  emailConfirmed?: boolean | null;
  phoneNumber: string = '';
  phoneNumberConfirmed?: boolean | null;
  twoFactorEnabled: boolean = false;
  lockoutEnd?: Date | null;
  lockoutEnabled: boolean = false;
  accessFailedCount: number = 0;
  jobTitle?: string | null;
  hireDate?: Date | null;
  defaultGoalGroupId: number = 0;
  defaultGoalTypeId: number = 0;
  defaultLanguageId: number = 0;
  defaultModuleId: number = 0;
  defaultStoreId: number = 0;
  defaultStoreLocationId: number = 0;
  defaultPosStoreId: number = 0;
  productionAutoPrint: boolean = false;
  productionStayScreen: boolean = false;
  profileFileId?: number | null;
  lastLoginAt?: Date | null;
  lastLogoutAt?: Date | null;
  passwordHash: string = '';
  salt: string = '';
  mustChangePasswordOnLogin: boolean = false;
  profileFileUrl?: string | null;
  invitationStatus: number = 0;
  roles: Role[] = [];
  apps: App[] = [];
  company = {
    id: 0,
    name: '',
  };
  isTpmPresent: boolean = false;
  isListerPresent: boolean = false;
  isDonationPresent: boolean = false;
  isPosPresent: boolean = false;
  isBypassLicenses: boolean = false;
  userSessionTimeout: number | null = null;
  imsDefaultWarehouseId: number = 0;
}

export class Role {
  id: number = 0;
  name: string = '';
}

export class App {
  id: number = 0;
  name: string = '';
  roles: Role[] = [];
}

export class UserRolesModel {
  id: number = 0;
  name: string = '';
  appId: number = 0;
  appName: string = '';
  permissions: UserPermissionsModel[] = [];
}

export class UserPermissionsModel {
  id: number = 0;
  name: string = '';
}
export class LoginModel {
  email: string = '';
  userId: number = 0;
  fullName: string = '';
  imsDefaultWarehouseId: number = 0;
  defaultWarehouseId: number = 0;
  userRole: string = '';
  companyId: number = 0;
  company: string = '';
  userName: string = '';
  storeID: number = 0;
  isNewUser: boolean = false;
  displayName: string = '';
  profileImgUrl: string = '';
  appID: number = 0;
  isActive: boolean = true;
  defaultModuleID: number = 0;
  outletID: number = 0;
  defaultProcessorLocationID?: number = 0;
  isTpmPresent: boolean = false;
  isListerPresent: boolean = false;
  isCompanyPortalPresent: boolean = false;
  isDonationPresent: boolean = false;
  isConsignmentPresent: boolean = false;
  isPosPresent: boolean = false;
  apps: App[] = [];
  productionScheduleType: string = '';
}
